import { forwardRef } from "react";

const CustomDateInput = forwardRef(({ value, onClick, onChange, name, ...props }, ref) => {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue.includes("-")) {
      return;
    }
    onChange?.(e);
  };

  return (
    <input
      {...props}
      ref={ref}
      name={name}
      value={value}
      onClick={onClick}
      onChange={handleInputChange}
      onKeyDown={(e) => {
        if (e.key === "-") {
          e.preventDefault();
        }
      }}
    />
  );
});

export default CustomDateInput;
